import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import {
  setForcedPreviewsAction,
  setProductIdAction,
  setSelectedAbstractProductAction,
  setSelectedAbstractProductNameAction,
  setSelectedBundleProductsAction,
} from '../slice';
import { Product } from '../types';
import fetchAbstractProductOperation from './fetchAbstractProductOperation';

const setSelectedAbstractProductOperation =
  (product: Product) => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const publicAssetProduct = store.publicAssetProduct.publicAssetAbstractProductData?.products.find(
      (p) => p.slug === product.slug,
    );
    if (publicAssetProduct) {
      dispatch(fetchAbstractProductOperation(publicAssetProduct.productId, publicAssetProduct.slug));
    }
    dispatch(setSelectedAbstractProductAction(store.publicAssetProduct.abstractProducts[product.slug]));
    dispatch(setSelectedAbstractProductNameAction(publicAssetProduct?.name || ''));
    dispatch(setProductIdAction(publicAssetProduct?.productId || 1));
    dispatch(setForcedPreviewsAction({}));
    dispatch(setSelectedBundleProductsAction([]));
  };

export default setSelectedAbstractProductOperation;
